import { addDays, addYears, differenceInDays, parseISO, startOfDay } from 'date-fns';

export interface Anniversary {
  title: string;
  date: Date;
  dDay: number;
}

export const calculateAnniversaries = (startDateString: string): Anniversary[] => {
  try {
    const startDate = parseISO(startDateString);
    const today = startOfDay(new Date());
    const list: Anniversary[] = [];

    // 1. Calculate 100-day milestones (up to 5000 days / ~13 years)
    for (let i = 100; i <= 5000; i += 100) {
      const date = addDays(startDate, i - 1);
      const dDay = differenceInDays(startOfDay(date), today);
      list.push({
        title: `${i}일`,
        date,
        dDay
      });
    }

    // 2. Calculate yearly anniversaries (up to 20 years)
    for (let i = 1; i <= 20; i++) {
      const date = addYears(startDate, i);
      const dDay = differenceInDays(startOfDay(date), today);
      list.push({
        title: `${i}주년`,
        date,
        dDay
      });
    }

    // 3. Filter and Sort
    return list
      .filter(item => item.dDay >= 0) // Exclude past anniversaries
      .sort((a, b) => a.dDay - b.dDay); // Sort by proximity
  } catch (e) {
    console.error('Anniversary calculation error:', e);
    return [];
  }
};
